import { createSlice, createAction, createSelector } from '@reduxjs/toolkit'

import { getLocationByIdSelector } from 'redux/reducers/profile'

const initialState = {
  alerts: [],
  alertsType: [],
  isFetchingAlerts: false,
  error: {
    code: null,
    message: null,
  },
}

//   {
//     "id": "24404b2d-7b59-4fa7-8cfa-1b172137fbb5",
//     "name": "Plug",
//     "description": {
//         "power_factor": 0.57,
//         "active_energy": 0.1,
//         "voltage": 230,
//         "panel_id": "1ec834d8-2146-4274-a5b6-5f8e0e66e5e2",
//         "panel_name": "Tariq home",
//         "meter_number": 1,
//         "device_name": "Plug",
//         "meter_id": "694e9868-c023-45e8-a4d5-fe6004bbf2cf",
//         "device_id": "b9c18fcb-e608-474d-aa99-86733fc6518b",
//         "channel": 18,
//         "description": "Low Power Factor: Plug is performing poorly. Power factor is 0.57. At least it should be 0.85."
//     },
//     "alert_type_id": "3e99d2dd-6965-47de-b773-ca0b4fb40afa",
//     "status": "Open",
//     "panel_id": "1ec834d8-2146-4274-a5b6-5f8e0e66e5e2",
//     "location_id": "3746daae-99e9-4257-9aeb-de2e778c550f",
//     "is_read": false,
//     "created_at": 1652346338
// }

export const getAlertSelector = (state) => state.alerts.alerts

export const getAlertsDataSelector = (state) => {
  return state.alerts.alerts.map((alert) => ({
    id: alert.id,
    status: alert.status,
    panel: alert.description?.panel_name || '',
    issueDeviceType: alert.name || '',
    issue: alert.description?.description || '',
    dateCreated: alert.created_at,
    dateUpdated: alert.updated_at,
    facility: getLocationByIdSelector(alert.location_id)(state)?.name || '',
    assignee: '', //// to do
    created: '', //// to do
  }))
}

export const getAlertsTypesSelector = (state) => state.alerts.alertsType
export const getIsFetchingAlertsSelector = (state) =>
  state.alerts.isFetchingAlerts
export const getAlertErrorSelector = (state) => state.alerts.error

export const getIsNewAlertsSelector = createSelector(
  getAlertSelector,
  (alerts) => {
    return alerts.some((alert) => !alert.is_read)
  }
)

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    getAlerts(state) {
      state.isFetchingAlerts = true
      state.error = initialState.error
    },
    gettingAlertSacusses(state, action) {
      state.isFetchingAlerts = false
      state.alerts = action.payload?.alerts
      state.alertsType = action.payload?.alerts_types
      state.error = initialState.error
    },
    gettingAlertFailed(state, action) {
      state.isFetchingAlerts = false
      state.alerts = []
      state.error = action.payload
    },
    setIsFetchingAlert(state, action) {
      state.isFetchingAlerts = action.payload
    },
    setAlerts(state, action) {
      state.alerts = action.payload
    },
  },
})

export const deleteAlert = createAction('alert/deleteAlert')

export const changeStatusAlert = createAction('alert/changeStatusAlert')

export const markAsReadAlerts = createAction('alert/markAsReadAlerts')

export const {
  getAlerts,
  gettingAlertSacusses,
  gettingAlertFailed,
  setIsFetchingAlert,
  setAlerts,
} = alertsSlice.actions

export default alertsSlice.reducer
